import { useEffect, useRef, useState } from "react";

/**
 * 场景按固定设计宽度绘制，通过容器实际宽度等比缩放，缩放不超过 1，
 * 保证宽屏上不会把设计稿拉糊。
 */
export function useSceneScale(designWidth: number) {
  const frameRef = useRef<HTMLDivElement>(null);
  const [scale, setScale] = useState(1);

  useEffect(() => {
    const frame = frameRef.current;
    if (!frame) return;
    const update = (width: number) => setScale(Math.min(width / designWidth, 1));
    const observer = new ResizeObserver((entries) => {
      update(entries[0]?.contentRect.width ?? designWidth);
    });
    observer.observe(frame);
    update(frame.clientWidth);
    return () => observer.disconnect();
  }, [designWidth]);

  return { frameRef, scale };
}
